module.exports = __webpack_public_path__ + "img/card_1.d7960a6e.png";